import { render } from "./Loading.vue?vue&type=template&id=29df032a&scoped=true"
const script = {}

import "./Loading.vue?vue&type=style&index=0&id=29df032a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29df032a"]])

export default __exports__